import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'app-z-card',
  templateUrl: './z-card.component.html',
  styleUrls: ['./z-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZCardComponent {
  readonly title: InputSignal<string> = input<string>();
  readonly value: InputSignal<string> = input<string>();
  readonly icon: InputSignal<string> = input<string>();
  readonly iconBackground: InputSignal<string> = input<string>('#8fb352');
  readonly showValue: InputSignal<boolean> = input<boolean>(true);
}
